const fundCategories = {
  'Miscellaneous Equity Other': 'Miscellaneous Equity Other',
  'United States Fixed Income': 'United States Fixed Income',
  'Greater China Equity': 'Greater China Equity',
  'Currency Alternative': 'Currency Alternative',
  'Global Large Cap Blend Equity': 'Global Large Cap Blend Equity',
  'Long-Short Strategy Alternative': 'Long-Short Strategy Alternative',
  'United States Municipal California Tax Preferred':
    'United States Municipal California Tax Preferred',
  'Aggressive Allocation': 'Aggressive Allocation',
  'Moderate Allocation': 'Moderate Allocation',
  'Global Large Cap Growth Equity': 'Global Large Cap Growth Equity',
  'Market Neutral Strategy Alternative': 'Market Neutral Strategy Alternative',
  'Other Fixed Income': 'Other Fixed Income',
  'United States Equity': 'United States Equity',
  'Natural Resources Sector Equity': 'Natural Resources Sector Equity',
  'Latin America Equity': 'Latin America Equity',
  Miscellaneous: 'Miscellaneous',
  'Precious Metals Commodities': 'Precious Metals Commodities',
  'Long Term High Quality Fixed Income': 'Long Term High Quality Fixed Income',
  'Global Small Cap Equity': 'Global Small Cap Equity',
  'United States Large Cap Blend Equity': 'United States Large Cap Blend Equity',
  'Global Emerging Markets Equity': 'Global Emerging Markets Equity',
  'United States Small Cap Equity': 'United States Small Cap Equity',
  'Health Care Equity': 'Health Care Equity',
  'Israel Equity': 'Israel Equity',
  'Financials Equity': 'Financials Equity',
  'Global Large Cap Value Equity': 'Global Large Cap Value Equity',
  'Short Term Government Bond': 'Short Term Government Bond',
  'Basic Materials Equity': 'Basic Materials Equity',
  'Ultra Short Term Bond': 'Ultra Short Term Bond',
  'Emerging Markets Equity': 'Emerging Markets Equity',
  'Short Term High Quality Fixed Income': 'Short Term High Quality Fixed Income',
  'Consumer Defensive Equity': 'Consumer Defensive Equity',
  'Industrials Equity': 'Industrials Equity',
  'Tactical Allocation': 'Tactical Allocation',
  'Trading Tools': 'Trading Tools',
  'United States Large Cap Value Equity': 'United States Large Cap Value Equity',
  'Europe Small Mid Cap Equity': 'Europe Small Mid Cap Equity',
  'United States Money Market': 'United States Money Market',
  'Consumer Cyclical Equity': 'Consumer Cyclical Equity',
  'Europe Equity': 'Europe Equity',
  'Utilities Equity': 'Utilities Equity',
  'Global Small Mid Cap Equity': 'Global Small Mid Cap Equity',
  'United States Mid Cap Equity': 'United States Mid Cap Equity',
  'United States Large Cap Growth Equity': 'United States Large Cap Growth Equity',
  'Communication Services Equity': 'Communication Services Equity',
  Convertibles: 'Convertibles',
  'Other Commodities': 'Other Commodities',
  'Japan Equity': 'Japan Equity',
  'Global Emerging Markets Fixed Income': 'Global Emerging Markets Fixed Income',
  'Intermediate Term High Quality Fixed Income': 'Intermediate Term High Quality Fixed Income',
  Allocation: 'Allocation',
  'Global Equity': 'Global Equity',
  'Long Term Low Quality Fixed Income': 'Long Term Low Quality Fixed Income',
  'All Cap Blend Equity': 'All Cap Blend Equity',
  'Canada Fixed Income': 'Canada Fixed Income',
  'Technology Equity': 'Technology Equity',
  'United States Municipal Fixed Income': 'United States Municipal Fixed Income',
  'Energy Equity': 'Energy Equity',
  'India Equity': 'India Equity',
  'Europe Large Cap Blend Equity': 'Europe Large Cap Blend Equity',
  'Real Estate Equity': 'Real Estate Equity',
  'Cautious Allocation': 'Cautious Allocation',
  'Asia ex-Japan Equity': 'Asia ex-Japan Equity',
  'Asia Equity': 'Asia Equity',
  'Multi Alternative': 'Multi Alternative',
  'Global Fixed Income': 'Global Fixed Income',
  'Target Date Allocation': 'Target Date Allocation',
  'China Equity - A Shares': 'China Equity - A Shares',
  'Europe ex-UK Equity': 'Europe ex-UK Equity',
  'Event Driven': 'Event Driven',
  'Global Emerging Markets Bond': 'Global Emerging Markets Bond',
  'Global Emerging Markets Corporate Bond': 'Global Emerging Markets Corporate Bond',
  'Global Flexible Bond': 'Global Flexible Bond',
  'Global Flexible Bond - USD Hedged': 'Global Flexible Bond - USD Hedged',
  'Global Large-Cap Blend Equity': 'Global Large-Cap Blend Equity',
  'Global Large-Cap Growth Equity': 'Global Large-Cap Growth Equity',
  'Global Large-Cap Value Equity': 'Global Large-Cap Value Equity',
  'Macro Trading USD': 'Macro Trading USD',
  'Options Trading': 'Options Trading',
  'Other Equity': 'Other Equity',
  'Property - Indirect Global': 'Property - Indirect Global',
  'Sector Equity Alternative Energy': 'Sector Equity Alternative Energy',
  'Sector Equity Healthcare': 'Sector Equity Healthcare',
  'Sector Equity Technology': 'Sector Equity Technology',
  'US Large-Cap Blend Equity': 'US Large-Cap Blend Equity',
  'US Large-Cap Growth Equity': 'US Large-Cap Growth Equity',
  'US Large-Cap Value Equity': 'US Large-Cap Value Equity',
  'USD Aggressive Allocation': 'USD Aggressive Allocation',
  'USD Cautious Allocation': 'USD Cautious Allocation',
  'USD Corporate Bond': 'USD Corporate Bond',
  'USD Corporate Bond - Short Term': 'USD Corporate Bond - Short Term',
  'USD Diversified Bond': 'USD Diversified Bond',
  'USD Flexible Bond': 'USD Flexible Bond',
  'USD High Yield Bond': 'USD High Yield Bond',
  'USD Moderate Allocation': 'USD Moderate Allocation',
  'USD Money Market': 'USD Money Market',
  'USD Ultra Short-Term Bond': 'USD Ultra Short-Term Bond',
};

const investmentStyles = {
  'Municipal California': 'Municipal California',
  'Multi Alternative': 'Multi Alternative',
  'Trading-Leveraged Commodities': 'Trading-Leveraged Commodities',
  'Volatility/ Derivative Strategy': 'Volatility/ Derivative Strategy',
  'Municipal New Jersey': 'Municipal New Jersey',
  'Municipal Arizona': 'Municipal Arizona',
  'Short Term Diversified Sectorial Bond': 'Short Term Diversified Sectorial Bond',
  'High Yield Emerging Markets Bond': 'High Yield Emerging Markets Bond',
  'Ultrashort Term Bond': 'Ultrashort Term Bond',
  'Municipal Oregon': 'Municipal Oregon',
  'Municipal Nebraska': 'Municipal Nebraska',
  'Short Term Municipal Bond': 'Short Term Municipal Bond',
  'Investment Grade Bond': 'Investment Grade Bond',
  'Market Neutral Strategy': 'Market Neutral Strategy',
  'Short Term Mid Quality': 'Short Term Mid Quality',
  'Municipal New York': 'Municipal New York',
  'Intermediate Term Mid Quality': 'Intermediate Term Mid Quality',
  'Ultra short- Low risk': 'Ultra short- Low risk',
  'High Yield Diversified Sectoral Bond': 'High Yield Diversified Sectoral Bond',
  'Short Term High Quality': 'Short Term High Quality',
  'Municipal Wisconsin': 'Municipal Wisconsin',
  'Municipal Virginia': 'Municipal Virginia',
  'Large Cap Blend': 'Large Cap Blend',
  'Inflation Protection': 'Inflation Protection',
  Miscellaneous: 'Miscellaneous',
  'Municipal Michigan': 'Municipal Michigan',
  'Trading-Inverse Debt': 'Trading-Inverse Debt',
  'Municipal North Carolina': 'Municipal North Carolina',
  'Short Term Emerging Markets Bond': 'Short Term Emerging Markets Bond',
  'Long-Short Strategy': 'Long-Short Strategy',
  'Municipal South Carolina': 'Municipal South Carolina',
  'Short Term Low Quality': 'Short Term Low Quality',
  'Large Cap Growth': 'Large Cap Growth',
  'Ultrashort Term Government Bond': 'Ultrashort Term Government Bond',
  'Municipal Pennsylvania': 'Municipal Pennsylvania',
  'Municipal Colorado': 'Municipal Colorado',
  'Small Cap Growth': 'Small Cap Growth',
  'Trading-Inverse Commodities': 'Trading-Inverse Commodities',
  'Municipal Ohio': 'Municipal Ohio',
  'Municipal Bond': 'Municipal Bond',
  'Global Diversified Sectoral Bond': 'Global Diversified Sectoral Bond',
  'Intermediate Term Low Quality': 'Intermediate Term Low Quality',
  'Municipal Kentucky': 'Municipal Kentucky',
  'High Yield Bond': 'High Yield Bond',
  'Municipal Georgia': 'Municipal Georgia',
  'Short Term Bond': 'Short Term Bond',
  'Short Term Government Bond': 'Short Term Government Bond',
  'Municipal Minnesota': 'Municipal Minnesota',
  'Preferred Stock': 'Preferred Stock',
  'Equity-oriented Balanced': 'Equity-oriented Balanced',
  'Leverage Strategy': 'Leverage Strategy',
  'Allocation/Balanced': 'Allocation/Balanced',
  'Diversified Sectoral Bond': 'Diversified Sectoral Bond',
  'Municipal Hawaii': 'Municipal Hawaii',
  'Intermediate Term Bond': 'Intermediate Term Bond',
  'Option Writing': 'Option Writing',
  'Small Cap Blend': 'Small Cap Blend',
  'Short Term Inflation Protection': 'Short Term Inflation Protection',
  'Municipal Montana': 'Municipal Montana',
  'Long Term High Yield Bond': 'Long Term High Yield Bond',
  'Long Term Municipal Bond': 'Long Term Municipal Bond',
  'Intermediate Term Municipal Bond': 'Intermediate Term Municipal Bond',
  'Long Term Inflation Protection': 'Long Term Inflation Protection',
  'Intermediate Term High Quality': 'Intermediate Term High Quality',
  'Municipal Oklahoma': 'Municipal Oklahoma',
  'Long Term High Quality': 'Long Term High Quality',
  'Tactical Allocation': 'Tactical Allocation',
  'Bank Loan': 'Bank Loan',
  'Municipal Tennessee': 'Municipal Tennessee',
  'Trading-Leveraged Equity': 'Trading-Leveraged Equity',
  'All Cap Blend': 'All Cap Blend',
  Gold: 'Gold',
  'Short Term High Yield Bond': 'Short Term High Yield Bond',
  'Long Term Government Bond': 'Long Term Government Bond',
  'Global High Yield Bond': 'Global High Yield Bond',
  'Managed Futures': 'Managed Futures',
  'Long Term Mid Quality': 'Long Term Mid Quality',
  Commodities: 'Commodities',
  'Municipal North Dakota': 'Municipal North Dakota',
  'Trading-Inverse Equity': 'Trading-Inverse Equity',
  'Municipal Maryland': 'Municipal Maryland',
  'Municipal Kansas': 'Municipal Kansas',
  'Trading-Leveraged Debt': 'Trading-Leveraged Debt',
  'Debt-oriented balanced': 'Debt-oriented balanced',
  'Municipal Missouri': 'Municipal Missouri',
  'Mid Cap Growth': 'Mid Cap Growth',
  'Municipal Louisiana': 'Municipal Louisiana',
  'Emerging Markets Diversified Sectoral Bond': 'Emerging Markets Diversified Sectoral Bond',
  'Bear Market Strategy': 'Bear Market Strategy',
  'Municipal Mississippi': 'Municipal Mississippi',
  Multicurrency: 'Multicurrency',
  'Municipal New Mexico': 'Municipal New Mexico',
  'Municipal Maine': 'Municipal Maine',
  'Municipal Arkansas': 'Municipal Arkansas',
  'Trading-Leveraged Miscellaneous': 'Trading-Leveraged Miscellaneous',
  'Mid Cap Value': 'Mid Cap Value',
  Convertibles: 'Convertibles',
  'Long Term Bond': 'Long Term Bond',
  'Mid Cap Blend': 'Mid Cap Blend',
  'Intermediate Term Government Bond': 'Intermediate Term Government Bond',
  'Intermediate Term US Government Bond': 'Intermediate Term US Government Bond',
  'Small Cap Value': 'Small Cap Value',
  'Municipal Connecticut': 'Municipal Connecticut',
  'Municipal Alabama': 'Municipal Alabama',
  'Intermediate Term Diversified Sectoral Bond': 'Intermediate Term Diversified Sectoral Bond',
  'Long Term Low Quality': 'Long Term Low Quality',
  'Emerging Markets Bond': 'Emerging Markets Bond',
  'Municipal Massachusetts': 'Municipal Massachusetts',
  'Investment Grade Government Bond': 'Investment Grade Government Bond',
  'Large Cap Value': 'Large Cap Value',
  'Target Date': 'Target Date',
  'Municipal Idaho': 'Municipal Idaho',
};

const sectors = {
  Athletics: 'Athletics',
  Communications: 'Communications',
  'Consumer Discretionary': 'Consumer Discretionary',
  'Consumer Staples': 'Consumer Staples',
  Defense: 'Defense',
  Energy: 'Energy',
  'Fashion Forward': 'Fashion Forward',
  Finance: 'Finance',
  'Fixed Income (Bonds)': 'Fixed Income (Bonds)',
  Grub: 'Grub',
  'Health Care': 'Health Care',
  Indexed: 'Indexed',
  Industrial: 'Industrial',
  Leisure: 'Leisure',
  'Pot-Folio': 'Pot-Folio',
  'Real Estate': 'Real Estate',
  Renewables: 'Renewables',
  Tech: 'Tech',
  'Short The Market': 'Short The Market',
};

export default {
  fundCategories,
  investmentStyles,
  sectors,
};
